module.exports = __webpack_public_path__ + "static/media/at.a8838a90.svg";